mutation OverwriteEditablesWithEditableScope(
    $overwrites: [InputOverwriteEditableWithEditableGroupScope]!
    $campaignId: ID!
) {
    overwriteEditablesWithEditableGroupScope(campaignId: $campaignId, overwrites: $overwrites) {
        _id
    }
}
